import {
  endOfMonth,
  endOfWeek,
  format,
  startOfMonth,
  startOfWeek,
} from "date-fns";

import { fetchMonthlyTimesheet } from "../api";
import { monthYearKey } from "utils";
import { timesheetKeys } from "components/timesheet/queries";
import { useQuery } from "@tanstack/react-query";

export default function useMonthlyTimesheet(date) {
  // Get the first day of the first week and last day of the last week of the visible calendar
  const firstDayOfMonth = startOfMonth(date);
  const lastDayOfMonth = endOfMonth(date);
  const calendarStart = startOfWeek(firstDayOfMonth, { weekStartsOn: 1 }); // 1 = Monday
  const calendarEnd = endOfWeek(lastDayOfMonth, { weekStartsOn: 1 });

  const { data: timesheetData, isLoading } = useQuery({
    queryKey: timesheetKeys.reviewCalendar(monthYearKey(firstDayOfMonth)),
    queryFn: () => fetchMonthlyTimesheet(calendarStart, calendarEnd),
  });

  const transformTimesheetData = () => {
    if (!timesheetData) return {};

    return timesheetData.reduce((acc, entry) => {
      const dateStr = entry.date;

      if (!acc[dateStr]) {
        acc[dateStr] = [];
      }

      acc[dateStr].push({
        id: entry.id,
        name: entry.description || "No description",
        time: "",
        datetime: `${dateStr}T00:00`,
        href: "#",
        hours: entry.logged_hours,
        project: entry.project?.name || "No project",
        jobId: entry.job.id,
        approved: entry?.approved_hours || 0,
        unapproved: entry?.unapproved_hours || 0,
      });

      return acc;
    }, {});
  };

  return {
    timesheetData,
    isLoading,
    transformedData: transformTimesheetData(),
  };
}
